export const ConfigKeyCases = "cases";
export const PinLength = 5;

export enum OccupancyType {
    Outbound = "Outbound",
    Inbound = "Inbound",
    ServiceBox = "ServiceBox"
}

export interface Case {
    storageCode: string;
    pickupCode: string;
    lockHandle?: string;
    description: string;
    type: OccupancyType;
    item?: Item;
    occupiedFrom?: string;
    occupiedUntil?: string;
    reservationUuid?: string;
    customerName: string;
    customerPhones: string[];
    customerEmails: string[];
    replacement: boolean;
    replacementDescription?: string;
    replacementItem?: Item;
    box?: Box;
}

export interface Box {
    lockHandle: string,
    name: string,
    size: string
}

export interface Item {
    name: string;
}

export interface Cases {
    [pinCode: string]: Case;
}

export interface ServiceOccupancyContent {
    occupancy: Case;
}

export function formatItem(defaultText: string, description?: string, item?: Item) {
    if (description && item) {
        return `${item.name} ${description}`;
    }
    if (item) {
        return item.name;
    }
    if (description) {
        return description;
    }
    return defaultText;
}
